/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_High_NeutralInputs */

const en_coach_risk_high_neutral = /** @type {(inputs: Coach_Risk_High_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your readiness is balanced, but your load has increased dangerously fast. Reduce volume or intensity for the next few days. A sharp ramp at any readiness level raises injury risk.`)
};

const de_coach_risk_high_neutral = /** @type {(inputs: Coach_Risk_High_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitschaft ausgeglichen, aber die Belastung ist gefährlich schnell gestiegen. Fahr Umfang oder Intensität in den nächsten Tagen runter. Ein steiler Anstieg erhöht das Verletzungsrisiko bei jeder Bereitschaftslage.`)
};

/**
* | output |
* | --- |
* | "Your readiness is balanced, but your load has increased dangerously fast. Reduce volume or intensity for the next few days. A sharp ramp at any readiness lev..." |
*
* @param {Coach_Risk_High_NeutralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_high_neutral = /** @type {((inputs?: Coach_Risk_High_NeutralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_High_NeutralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_high_neutral(inputs)
	return de_coach_risk_high_neutral(inputs)
});